/**
 * UUIDv7 (RFC 9562) generovaný na klientovi: 48bitový timestamp (ms) v prvních 6 bajtech,
 * verze 7 a varianta, zbytek náhodně z `crypto.getRandomValues`.
 *
 * Phoenix entity používají UUIDv7 primární klíče generované serverem. Pro offline-first / dávkové
 * scénáře (např. Cost Scheme agenda) smí ID nových záznamů předgenerovat klient a poslat ho v uložení –
 * server ho respektuje jako PK, takže po uložení není potřeba párovat serverem přidělené ID zpět
 * (položka žije pod stabilním ID od vzniku: přežije autosave i otevřený detail). Časové řazení v7
 * zachovává lokalitu clusterovaného indexu i pro klientem vytvořené řádky.
 */
export function uuidv7(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);

  const ts = Date.now();
  bytes[0] = Math.floor(ts / 2 ** 40) & 0xff;
  bytes[1] = Math.floor(ts / 2 ** 32) & 0xff;
  bytes[2] = Math.floor(ts / 2 ** 24) & 0xff;
  bytes[3] = Math.floor(ts / 2 ** 16) & 0xff;
  bytes[4] = Math.floor(ts / 2 ** 8) & 0xff;
  bytes[5] = ts & 0xff;

  // Verze 7 (horní 4 bity bajtu 6) a varianta 10xx (horní 2 bity bajtu 8).
  bytes[6] = (bytes[6] & 0x0f) | 0x70;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'));
  return (
    hex.slice(0, 4).join('') +
    '-' +
    hex.slice(4, 6).join('') +
    '-' +
    hex.slice(6, 8).join('') +
    '-' +
    hex.slice(8, 10).join('') +
    '-' +
    hex.slice(10, 16).join('')
  );
}
